import { render, staticRenderFns } from "./CustomerDisplayPage.vue?vue&type=template&id=94017084&scoped=true&"
import script from "./CustomerDisplayPage.vue?vue&type=script&lang=js&"
export * from "./CustomerDisplayPage.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDisplayPage.vue?vue&type=style&index=0&id=94017084&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Users/Mac/Desktop/Code/permtang/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94017084",
  null
  
)

export default component.exports